import TextInput from '$src/common/TextInput'
import {Component, React, observer} from '$src/handy'
import * as css from './LoginPage.css'
import Box from '$src/common/Box'
import GenericButton from '$src/common/GenericButton'
import {Form} from '$src/common/forms'
import login from '$src/auth/sagas/login'
import PageLayout from '$src/common/PageLayout/PageLayout';

@observer
export default class LoginPage extends Component<{}, {error?: string, submittin: boolean}> {
  constructor(props: {}, context: any) {
    super(props, context)
    this.state = {error: undefined, submittin: false}
  }
  onSubmit = ({un, pw}: any) => {
    this.setState({submittin: true})
    this.runSaga(login, {name: un, password: pw}).then(
      () => {
        console.log('login successful')
      },
      (error: any) => {
        console.log(error)
        this.setState(s => ({...s, error: error.message || error.error || 'Unauthorized', submittin: false}))
      },
    )
  }

  render() {
    return (
      <PageLayout>
        <div className={css.body}>
          <Box css={{container: css.box}}>
            <Form onSubmit={this.onSubmit}>
              <TextInput.Field name="un" type="text" label="USERNAME" placeholder="eg name@domain.com" />
              <TextInput.Field name="pw" type="password" label="PASSWORD" placeholder="eg sldk@3k&22sH/" />
              {this.state.error && <div className={css.error}>Error occured: {this.state.error}</div>}
              <div className={css.bottom}>
                <GenericButton variant="bold" type="submit" disabled={this.state.submittin}>
                  LOGIN
                </GenericButton>
              </div>
            </Form>
          </Box>
        </div>
      </PageLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/auth/LoginPage/LoginPage.tsx